
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { SKILL_EXTRACT_SEO_OPTIMIZED_EXAMPLES } from '@/constants/skillExamples';
import { Divider, VStack } from '@chakra-ui/react';
import { GetStaticProps } from 'next';
import I18nProvider from 'next-translate/I18nProvider';
import useTranslation from 'next-translate/useTranslation';
import HeadModule from '../../components/Modules/HeadModule';
import ServiceHeader from '../../components/Modules/ServiceHeader';
import ServiceList from '../../components/Modules/ServiceList';
import ServiceGroupButtons from '../../components/ServiceGroup/ServiceGroupButtons';
import SkillSingleInputPlayground from '../../components/Skill/SingleInputOutput/SkillSingleInputPlayground';
import SkillOptions from '../../components/Skill/SkillOptions';
import { COPYWRITING_FOR_PRODUCTS_SKILLS, SKILL_EXTRACT_SEO_OPTIMIZED_TEXT, getFourRandomSkills, } from '../../constants/skills';
import examplesDE from '../../locales/de/examples.json';
import examplesEN from '../../locales/en/examples.json';
import examplesFR from '../../locales/fr/examples.json';
import { SkillProvider } from '../../utils/SkillContext';
const Page = ({ otherServices }: any) => {
    const { lang } = useTranslation();
    const skillsGroup = COPYWRITING_FOR_PRODUCTS_SKILLS;
    const maxLength = 10000;
    const { t } = useTranslation('skill-extract-optimized-seo-text');
    return (<I18nProvider lang={lang} namespaces={{ examplesFR, examplesEN, examplesDE }}>
      <>
        <HeadModule title='meta_title_skill_extract_optimized_seo_text' description='meta_description_skill_extract_optimized_seo_text'/>
        <VStack w='full' spacing={20}>
          <VStack w='full' spacing={10}>
            <ServiceHeader serviceGroup={skillsGroup}/>
            <ServiceGroupButtons serviceGroup={skillsGroup}/>
            <SkillProvider skill={SKILL_EXTRACT_SEO_OPTIMIZED_TEXT} skillExamples={SKILL_EXTRACT_SEO_OPTIMIZED_EXAMPLES} skillGroup={skillsGroup}>
              <SkillSingleInputPlayground maxLength={maxLength}>
                <SkillOptions title={t('skill_extract_optimized_seo_text_subtitle')}/>
              </SkillSingleInputPlayground>
            </SkillProvider>
          </VStack>
          <Divider variant='separator2' w={64}/>
          <ServiceList title={t('common:our_other_products')} serviceGroups={JSON.parse(otherServices)}/>
        </VStack>
      </>
    </I18nProvider>);
};
const getStaticProps: GetStaticProps = async () => {
    const otherServices = getFourRandomSkills();
    return {
        props: {
            otherServices: JSON.stringify(otherServices),
        },
        revalidate: 900,
    };
};
// noinspection JSUnusedGlobalSymbols
export default Page;

    async function __Next_Translate__getStaticProps__19bb2fd5b34__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/copywriting/extract-seo-optimized-text',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19bb2fd5b34__ as getStaticProps }
  